import { render, staticRenderFns } from "./CreditList.vue?vue&type=template&id=623d3d23&scoped=true"
import script from "./CreditList.vue?vue&type=script&lang=js"
export * from "./CreditList.vue?vue&type=script&lang=js"
import style0 from "./CreditList.vue?vue&type=style&index=0&id=623d3d23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d3d23",
  null
  
)

export default component.exports